// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6b42f07de595b5b35086169292510ddc0671efad.chunk.bundle.js";
};